export default __webpack_public_path__ + "f1be57b99e24714a77e397c1bc70654e.png";